import "../styles/main.scss"

import common from "./modules/common"
//import megaMenu from "./modules/megaMenu"
import wpMenu from "./modules/wpMenu"
import careers from "./modules/careers"
import events from "./modules/events"
import location from "./modules/location"
//import locations from "./modules/locations"
import gallerySlider from "./modules/gallery-slider"

common();
gallerySlider();
wpMenu();

/* if(document.querySelector('#mega-menu')) {
  megaMenu();
} */

if(document.querySelector('body').classList.contains('careers')) {
  careers();
}

if(document.querySelector('body').classList.contains('single-events')) {
  events();
}

if(document.querySelector('body').classList.contains('post-type-archive-locations')) {
  locations();
}

if(document.querySelector('body').classList.contains('single-locations')) {
  location();
}